<div class="panel-title" i18n>Options</div>
<div class="row mt-3">
  <div class="col-12">
    <app-booking-select
      [ctrl]="bookingIdCtrl"
      tooltipText="Select a booking to assign to this document. In AdvanceCM, this document will appear in the booking details."
      i18n-tooltipText
      i18n-placeholder
      placeholder="Assigned Booking"
      [showBlankItem]="true"
    >
    </app-booking-select>
  </div>
  <div class="col-12">
    <mat-form-field2 class="mat-block">
      <app-mat-date-input
        [formControl]="expiredAtCtrl"
        i18n-placeholder
        placeholder="Expiration Date"
        [min]="minExpiredDate"
        i18n-matTooltip
        matTooltip="Change the date that this document will expire."
      ></app-mat-date-input>

      <span matPrefix><i class="fal fa-calendar"></i> </span>
      <span matSuffix (click)="expiredAtCtrl.reset()" class="clickable" *ngIf="expiredAtCtrl.value">
        <i class="far fa-times"></i>
      </span>
    </mat-form-field2>
  </div>
  <div class="col-12">
    <app-form-tags2
      [formControl]="tagsCtrl"
      i18n-label
      label="Select or Create Tag(s)"
      [items]="tags$ | async"
      i18n-placeholder
      placeholder="Type to pick or create tag"
      i18n-matTooltip
      matTooltip="Select an existing tag, or create a new tag to assign to this document. Tags allow you to quickly filter templates that have certain attributes."
    ></app-form-tags2>
  </div>
</div>
